import { Box, Button, Flex, FormLabel, Input } from "@chakra-ui/react";
import { Country, State } from "country-state-city";
import JobDescriptionEditor from "./JobDescriptionEditor/JobDescriptionEditor";
import { Modal, Spinner } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import PhoneInput from "react-phone-input-2";
import Select from "react-select";
import { handleGenerateJD } from "../../Utils";
import { useEffect, useState } from "react";
import axios from "axios";
import config from "../../config";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";

//Schema For Formik validation

function JobAddModal({
  formSubmitLoading,
  jobLoading,
  ViewPost,
  handlePostClose,
  formik,
  selectedOption,
  handleChange,
  selectedClientContactName,
  setSelectedClientContactName,
  setSelectedCountry,
  setSelectedState,
  setSelectedCity,
  contacts,
  jobpost,
  handleInputs,
  selectedCountry,
  selectedState,
  City,
  selectedCity,
  selectedAccountManager,
  alluserTeams,
  selectedTeamLeader,
  selectedTeamD,
  selectedRecruiter,
  recruiters,
  industries,
  getCurrentLoggedInUserName,
  jdLoading,
  options,
  setJobpost,
  setSelectedTeamD,
  setSelectedTeamLeader,
  setJobBranch,
  jobBranch,
  setSelectedRecruiter,
  setSelectedAccountManager,
  setRecruiters,
  setJdLoading,
  view,
  edit,
  viewId
}) {
  const [branchLoading, setBranchLoading] = useState(false);
  const [allFetchedBranches, setAllFetchedBranches] = useState([]);
  const [cookie] = useCookies(["role", "id", "token"]);
  const fetchAllBranches = async () => {

    setBranchLoading(true);
    try {
      const response = await axios.get(
        `${config?.apiUrl}/api/get_all_client_branch/${viewId || selectedOption?.value}`,
        {
          headers: {
            Authorization: `Bearer ${cookie.token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const branches = response?.data?.data || [];
      setAllFetchedBranches(branches);
      setBranchLoading(false);
      // 

      // handle the branches data as needed
    } catch (error) {
      setBranchLoading(false);
      setAllFetchedBranches([]);
      toast.error(error, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };
  useEffect(() => {

    if (viewId || selectedOption?.value) {
      fetchAllBranches();
    }
  }, [selectedOption, viewId]);
  const minDate = new Date().toISOString().split("T")[0];
  return (
    <Modal
      show={ViewPost}
      onHide={handlePostClose}
      size="xl"
      backdrop="static"
      closeOnOverlayClick={false}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" className="usertitle">
          {edit ? "Edit Job" : " Quick Add - Job"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={formik.handleSubmit}>
          <Container>
            <Row>
              <Col lg={4} md={6} style={{ marginBottom: "1rem" }}>
                <FormLabel
                  ms="4px"
                  fontSize="sm"
                  fontWeight="400"
                  fontFamily="Roboto"
                  color="#000000"
                >
                  Job Title <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <Input
                  variant="auth"
                  fontSize="sm"
                  ms="4px"
                  type="text"
                  placeholder="Job Title"
                  size="lg"
                  name="jobtitle"
                  value={formik.values.jobtitle}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  style={{
                    width: "100%",
                    height: "37px",
                    border:
                      formik.touched.jobtitle && formik.errors.jobtitle
                        ? "1px solid red"
                        : "1px solid #ccc",
                  }}
                />
                {formik.touched.jobtitle && formik.errors.jobtitle ? (
                  <div style={{ color: "red", fontSize: "14px" }}>
                    {formik.errors.jobtitle}
                  </div>
                ) : null}
              </Col>

              {view !== "accountview" && view !== "contactview" && (
                <Col lg={4} md={6} style={{ marginBottom: "1rem" }}>
                  <FormLabel
                    ms="4px"
                    fontSize="sm"
                    fontWeight="400"
                    fontFamily="Roboto"
                    color="#000000"
                  >
                    Clients
                  </FormLabel>
                  <Select
                    name="clients"
                    value={selectedOption}
                    onChange={handleChange}
                    options={options}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        width: "100%",
                        height: "37px",
                        border:
                          formik.touched.clients && formik.errors.clients
                            ? "1px solid red"
                            : "1px solid #ccc",
                      }),
                    }}
                  />
                  {formik.touched.clients && formik.errors.clients ? (
                    <div style={{ color: "red", fontSize: "14px" }}>
                      {formik.errors.clients}
                    </div>
                  ) : null}
                </Col>
              )}
              <Col lg={4} md={6} style={{ marginBottom: "1rem" }}>
                <FormLabel
                  ms="4px"
                  fontSize="sm"
                  fontWeight="400"
                  fontFamily="Roboto"
                  color="#000000"
                >
                  Branch
                </FormLabel>
                <Select
                  name="branch"
                  value={jobBranch}
                  onChange={(selectedOption) => {
                    setJobBranch(selectedOption);
                    formik.setFieldValue(
                      "branch",
                      selectedOption ? selectedOption.value : ""
                    );
                    const branch = allFetchedBranches?.find(
                      (branch) => branch._id === selectedOption.value
                    );
                    // setting Country
                    setSelectedCountry({
                      name: branch.address.country,
                      isoCode: branch.address.countryCode,
                    });
                    setJobpost({ ...jobpost, country: branch.address.country });
                    formik.setFieldValue("country", branch.address.country);
                    // setting State
                    setSelectedState({
                      name: branch.address.state,
                      isoCode: branch.address.stateCode,
                      countryCode: branch.address.countryCode,
                    });
                    setJobpost({ ...jobpost, state: branch.address.state });
                    formik.setFieldValue("state", branch.address.state);
                    // setting city
                    setSelectedCity({
                      name: branch.address.city,
                      stateCode: branch.address.stateCode,
                    });
                    setJobpost({ ...jobpost, city: branch.address.city });
                    formik.setFieldValue("city", branch.address.city);

                    // settting the address
                    formik.setFieldValue("jobAddress", branch.address.street);
                    // setting pincode
                    formik.setFieldValue("pincode", branch.address.pincode);
                    // setting client contact name
                    const contact = contacts?.find(
                      (contact) => contact._id === branch?.contactPersonId
                    );
                    setSelectedClientContactName({
                      value: contact?._id,
                      label: contact?.accountOwnerName,
                    });
                    formik.setFieldValue("clientContactName", contact?._id);
                  }}
                  options={allFetchedBranches?.map((branch) => {
                    return {
                      label: branch.branchName,
                      value: branch._id,
                    };
                  })}
                  onBlur={formik.handleBlur}
                  styles={{
                    width: "100%",
                    height: "37px",
                    border:
                      formik.touched.teamleader && formik.errors.teamleader
                        ? "1px solid red"
                        : "1px solid #ccc",
                  }}
                />
                {formik.touched.teamleader && formik.errors.teamleader ? (
                  <div style={{ color: "red", fontSize: "14px" }}>
                    {formik.errors.teamleader}
                  </div>
                ) : null}
              </Col>
              {view !== "contactview" && (
                <Col lg={4} md={6} style={{ marginBottom: "1rem" }}>
                  <FormLabel
                    ms="4px"
                    fontSize="sm"
                    fontWeight="400"
                    fontFamily="Roboto"
                    color="#000000"
                  >
                    Client Contact Name <span style={{ color: "red" }}>*</span>
                  </FormLabel>
                  {/* {contacts?.length === 0 ? (
                  <>
                    <Select
                      name="clientContactName"
                      value={selectedClientContactName}
                      onChange={handleInputs}
                      options={[]}
                      styles={{
                        width: "100%",
                        height: "37px",
                        border:
                          formik.touched.clientContactName &&
                          formik.errors.clientContactName
                            ? "1px solid red"
                            : "1px solid #ccc",
                      }}
                    />
                  </>
                ) : ( */}
                  <>
                    <Select
                      name="clientContactName"
                      value={selectedClientContactName}
                      onChange={(selectedOption) => {
                        setSelectedClientContactName(selectedOption);
                        formik.setFieldValue(
                          "clientContactName",
                          selectedOption?.value
                        );
                      }}
                      onBlur={formik.handleBlur}
                      options={contacts?.map((val) => {
                        return {
                          label: val.accountOwnerName,
                          value: val._id,
                        };
                      })}
                      styles={{
                        width: "100%",
                        height: "37px",
                        border:
                          formik.touched.clientContactName &&
                            formik.errors.clientContactName
                            ? "1px solid red"
                            : "1px solid #ccc",
                      }}
                    />
                  </>
                  {formik?.touched?.clientContactName &&
                    formik?.errors?.clientContactName ? (
                    <div style={{ color: "red", fontSize: "14px" }}>
                      {formik?.errors?.clientContactName}
                    </div>
                  ) : null}
                </Col>
              )}

              <Col lg={4} md={6} style={{ marginBottom: "1rem" }}>
                <FormLabel
                  ms="4px"
                  fontSize="sm"
                  fontWeight="400"
                  fontFamily="Roboto"
                  color="#000000"
                >
                  Country <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <div style={{ width: "100%", height: "37px" }}>
                  <Select
                    name="country"
                    options={Country.getAllCountries()}
                    placeholder="Select Country"
                    getOptionLabel={(options) => {
                      return options["name"];
                    }}
                    getOptionValue={(options) => {
                      return options["name"];
                    }}
                    value={selectedCountry}
                    onChange={(item) => {
                      setSelectedCountry(item);
                      setJobpost({ ...jobpost, country: item.name });
                      formik.setFieldValue("country", item.name);
                    }}
                    classNamePrefix={
                      formik.touched.country &&
                      formik.errors.country &&
                      "democlass"
                    }
                    styles={{
                      border:
                        formik.touched.country && formik.errors.country
                          ? "1px solid red"
                          : "1px solid #ccc",
                    }}
                  />
                  {formik.touched.country && formik.errors.country ? (
                    <div style={{ color: "red", fontSize: "14px" }}>
                      {formik.errors.country}
                    </div>
                  ) : null}
                </div>
              </Col>
              <Col lg={4} md={6} style={{ marginBottom: "1rem" }}>
                <FormLabel
                  ms="4px"
                  fontSize="sm"
                  fontWeight="400"
                  fontFamily="Roboto"
                  color="#000000"
                >
                  State <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <Select
                  name="state"
                  options={State?.getStatesOfCountry(selectedCountry?.isoCode)}
                  placeholder="Select State"
                  getOptionLabel={(options) => {
                    return options["name"];
                  }}
                  getOptionValue={(options) => {
                    return options["name"];
                  }}
                  value={selectedState}
                  onChange={(item) => {
                    setSelectedState(item);
                    setJobpost({ ...jobpost, state: item.name });
                    formik.setFieldValue("state", item.name);
                  }}
                  classNamePrefix={
                    formik.touched.state && formik.errors.state && "democlass"
                  }
                  styles={{
                    border:
                      formik.touched.state && formik.errors.state
                        ? "1px solid red"
                        : "1px solid #ccc",
                  }}
                />
                {formik.touched.state && formik.errors.state ? (
                  <div style={{ color: "red", fontSize: "14px" }}>
                    {formik.errors.state}
                  </div>
                ) : null}
              </Col>
              <Col lg={4} md={6} style={{ marginBottom: "1rem" }}>
                <FormLabel
                  ms="4px"
                  fontSize="sm"
                  fontWeight="400"
                  fontFamily="Roboto"
                  color="#000000"
                >
                  City <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <Select
                  name="city"
                  options={City.getCitiesOfState(
                    selectedState?.countryCode,
                    selectedState?.isoCode
                  )}
                  placeholder="Select City"
                  getOptionLabel={(options) => {
                    return options["name"];
                  }}
                  getOptionValue={(options) => {
                    return options["name"];
                  }}
                  value={selectedCity}
                  onChange={(item) => {
                    setSelectedCity(item);
                    setJobpost({ ...jobpost, city: item.name });
                    formik.setFieldValue("city", item.name);
                  }}
                  classNamePrefix={
                    formik.touched.city && formik.errors.city && "democlass"
                  }
                  styles={{
                    border:
                      formik.touched.city && formik.errors.city
                        ? "1px solid red"
                        : "1px solid #ccc",
                  }}
                />
                {formik.touched.city && formik.errors.city ? (
                  <div style={{ color: "red", fontSize: "14px" }}>
                    {formik.errors.city}
                  </div>
                ) : null}
              </Col>
              <Col lg={4} md={6} style={{ marginBottom: "1rem" }}>
                <FormLabel
                  ms="4px"
                  fontSize="sm"
                  fontWeight="400"
                  fontFamily="Roboto"
                  color="#000000"
                >
                  Address <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <Input
                  variant="auth"
                  fontSize="sm"
                  ms="4px"
                  type="text"
                  placeholder="Job Address"
                  size="lg"
                  name="jobAddress"
                  value={formik.values.jobAddress}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  style={{
                    width: "100%",
                    height: "37px",
                    border:
                      formik.touched.jobAddress && formik.errors.jobAddress
                        ? "1px solid red"
                        : "1px solid #ccc",
                  }}
                />
                {formik.touched.jobAddress && formik.errors.jobAddress ? (
                  <div style={{ color: "red", fontSize: "14px" }}>
                    {formik.errors.jobAddress}
                  </div>
                ) : null}
              </Col>
              <Col lg={4} md={6} style={{ marginBottom: "1rem" }}>
                <FormLabel
                  ms="4px"
                  fontSize="sm"
                  fontWeight="400"
                  fontFamily="Roboto"
                  color="#000000"
                >
                  Pincode <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <Input
                  variant="auth"
                  fontSize="sm"
                  ms="4px"
                  type="text"
                  placeholder="Pincode"
                  size="lg"
                  name="pincode"
                  value={formik.values.pincode}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  style={{
                    width: "100%",
                    height: "37px",
                    border:
                      formik.touched.pincode && formik.errors.pincode
                        ? "1px solid red"
                        : "1px solid #ccc",
                  }}
                />
                {formik.touched.pincode && formik.errors.pincode ? (
                  <div style={{ color: "red", fontSize: "14px" }}>
                    {formik.errors.pincode}
                  </div>
                ) : null}
              </Col>
              <Col lg={4} md={6} style={{ marginBottom: "1rem" }}>
                <FormLabel
                  ms="4px"
                  fontSize="sm"
                  fontWeight="400"
                  fontFamily="Roboto"
                  color="#000000"
                >
                  Target Date <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <Input
                  variant="auth"
                  fontSize="sm"
                  ms="4px"
                  type="date"
                  placeholder="Target Date"
                  size="lg"
                  name="targetdate"
                  // value={formik?.values?.targetdate && new Date(formik?.values?.targetdate).toISOString()?.split("T")[0]}
                  value={
                    formik?.values?.targetdate
                      ? (() => {
                        const dateStr = formik.values.targetdate;
                        let date;

                        if (dateStr.includes("/")) {
                          // Handle "DD/MM/YYYY"
                          const [day, month, year] = dateStr.split("/");
                          date = new Date(`${year}-${month}-${day}`);
                        } else {
                          // Handle ISO or timestamp
                          date = new Date(dateStr);
                        }

                        // Return in yyyy-mm-dd format
                        return date.toISOString().split("T")[0];
                      })()
                      : ""
                  }
                  onChange={formik?.handleChange}
                  onBlur={formik.handleBlur}
                  min={minDate}
                  style={{
                    width: "100%",
                    cursor: "pointer",
                    height: "37px",
                    border:
                      formik.touched.targetdate && formik.errors.targetdate
                        ? "1px solid red"
                        : "1px solid #ccc",
                  }}
                />
                {formik.touched.targetdate && formik.errors.targetdate ? (
                  <div style={{ color: "red", fontSize: "14px" }}>
                    {formik.errors.targetdate}
                  </div>
                ) : null}
              </Col>

              <Col lg={4} md={6} style={{ marginBottom: "1rem" }}>
                <FormLabel
                  ms="4px"
                  fontSize="sm"
                  fontWeight="400"
                  fontFamily="Roboto"
                  color="#000000"
                >
                  Team
                </FormLabel>
                <Select
                  name="team"
                  value={selectedAccountManager}
                  onChange={(selectedOption) => {
                    const teamLeads = alluserTeams.filter(
                      (team) => team._id === selectedOption.value
                    );
                    setSelectedTeamD(teamLeads[0]);
                    setSelectedTeamLeader(null);
                    setSelectedRecruiter(null);
                    setSelectedAccountManager(selectedOption);
                    formik.setFieldValue("team", `${selectedOption?.value}`);
                  }}
                  options={alluserTeams.map((team) => ({
                    value: team?._id,
                    label: team.teamName,
                  }))}
                  onBlur={formik.handleBlur}
                  styles={{
                    width: "100%",
                    height: "37px",
                    border:
                      formik.touched.teamleader && formik.errors.teamleader
                        ? "1px solid red"
                        : "1px solid #ccc",
                  }}
                />
                {formik.touched.teamleader && formik.errors.teamleader ? (
                  <div style={{ color: "red", fontSize: "14px" }}>
                    {formik.errors.teamleader}
                  </div>
                ) : null}
              </Col>
              <Col lg={4} md={6} style={{ marginBottom: "1rem" }}>
                <FormLabel
                  ms="4px"
                  fontSize="sm"
                  fontWeight="400"
                  fontFamily="Roboto"
                  color="#000000"
                >
                  Team Leader
                </FormLabel>
                <Select
                  name="teamleader"
                  value={selectedTeamLeader}
                  onChange={(selectedOption) => {
                    setSelectedTeamLeader(selectedOption);
                    formik.setFieldValue(
                      "teamleader",
                      selectedOption ? selectedOption.value : ""
                    );
                    const memberIds =
                      selectedTeamD?.membersByLead[selectedOption.value];
                    const recruiters = selectedTeamD?.members?.filter(
                      (recruiter) => memberIds?.includes(recruiter._id)
                    );
                    if (recruiters.length === 0) {
                      setRecruiters(selectedTeamD?.members);
                    } else {
                      setSelectedRecruiter(null);
                      setRecruiters(recruiters);
                    }
                  }}
                  options={
                    selectedTeamD?.lead
                      ? [
                        ...selectedTeamD?.lead.map((teamlead) => ({
                          // value: `${user.firstName} ${user.lastName}`,
                          value: teamlead?._id,
                          label: `${teamlead.firstName} ${teamlead.lastName}`,
                        })),
                        {
                          value: selectedTeamD?.accountmanager?._id,
                          label:
                            selectedTeamD?.accountmanager?.firstName +
                            " " +
                            selectedTeamD?.accountmanager?.lastName,
                        },
                      ]
                      : []
                  }
                  onBlur={formik.handleBlur}
                  styles={{
                    width: "100%",
                    height: "37px",
                    border:
                      formik.touched.teamleader && formik.errors.teamleader
                        ? "1px solid red"
                        : "1px solid #ccc",
                  }}
                />
                {formik.touched.teamleader && formik.errors.teamleader ? (
                  <div style={{ color: "red", fontSize: "14px" }}>
                    {formik.errors.teamleader}
                  </div>
                ) : null}
              </Col>
              <Col lg={4} md={6} style={{ marginBottom: "1rem" }}>
                <FormLabel
                  ms="4px"
                  fontSize="sm"
                  fontWeight="400"
                  fontFamily="Roboto"
                  color="#000000"
                >
                  Recruiters
                </FormLabel>
                <Select
                  value={selectedRecruiter}
                  name="recruiter"
                  onChange={(selectedOption) => {
                    setSelectedRecruiter(selectedOption);
                    formik.setFieldValue(
                      "recruiter",
                      `${selectedOption.value}`
                    );
                  }}
                  options={recruiters?.map((recruiter) => ({
                    // value: `${user.firstName} ${user.lastName}`,
                    value: recruiter?._id,
                    label: `${recruiter.firstName} ${recruiter.lastName}`,
                  }))}
                  onBlur={formik.handleBlur}
                  styles={{
                    width: "100%",
                    height: "37px",
                    border:
                      formik.touched.recruiter && formik.errors.recruiter
                        ? "1px solid red"
                        : "1px solid #ccc",
                  }}
                />
                {formik.touched.recruiter && formik.errors.recruiter ? (
                  <div style={{ color: "red", fontSize: "14px" }}>
                    {formik.errors.recruiter}
                  </div>
                ) : null}
              </Col>
              <Col lg={4} md={6} style={{ marginBottom: "1rem" }}>
                <FormLabel
                  ms="4px"
                  fontSize="sm"
                  fontWeight="400"
                  fontFamily="Roboto"
                  color="#000000"
                >
                  Experience (in years) <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <Input
                  className="form-control"
                  name="experience"
                  type="number"
                  placeholder="Experience"
                  min="0"
                  max="100"
                  value={formik.values.experience}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  style={{
                    width: "100%",
                    height: "37px",
                    border:
                      formik.touched.experience && formik.errors.experience
                        ? "1px solid red"
                        : "1px solid #ccc",
                  }}
                ></Input>
                {formik.touched.experience && formik.errors.experience ? (
                  <div style={{ color: "red", fontSize: "14px" }}>
                    {formik.errors.experience}
                  </div>
                ) : null}
              </Col>
              <Col lg={4} md={6} style={{ marginBottom: "24px" }}>
                <FormLabel
                  ms="4px"
                  fontSize="sm"
                  fontWeight="400"
                  fontFamily="Roboto"
                  color="#000000"
                >
                  No. Of Position <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <Input
                  variant="auth"
                  fontSize="sm"
                  ms="4px"
                  type="text"
                  placeholder="Number of Position"
                  size="lg"
                  name="numberofPosition"
                  value={formik.values.numberofPosition}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  style={{
                    width: "100%",
                    height: "37px",
                    cursor: "pointer",
                    border:
                      formik.touched.numberofPosition &&
                        formik.errors.numberofPosition
                        ? "1px solid red"
                        : "1px solid #ccc",
                  }}
                />
                {formik.touched.numberofPosition &&
                  formik.errors.numberofPosition ? (
                  <div style={{ color: "red", fontSize: "14px" }}>
                    {formik.errors.numberofPosition}
                  </div>
                ) : null}
              </Col>
              <Col lg={4} md={6} style={{ marginBottom: "1rem" }}>
                <FormLabel
                  ms="4px"
                  fontSize="sm"
                  fontWeight="400"
                  fontFamily="Roboto"
                  color="#000000"
                >
                  Status <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <select
                  className="form-control"
                  name="status"
                  value={formik.values.status}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  style={{
                    width: "100%",
                    height: "37px",
                    border:
                      formik.touched.status && formik.errors.status
                        ? "1px solid red"
                        : "1px solid #ccc",
                  }}
                >
                  <option disabled={true} value="">
                    Status <span style={{ color: "red" }}>*</span>
                  </option>
                  <option value="Active">Active</option>
                  <option value="Deactive">Deactive</option>
                  <option value="On Hold">On Hold</option>
                  <option value="Cancelled">Cancelled</option>
                  <option value="Target Date Expired">
                    Target Date Expired
                  </option>
                </select>
                {formik.touched.status && formik.errors.status ? (
                  <div style={{ color: "red", fontSize: "14px" }}>
                    {formik.errors.status}
                  </div>
                ) : null}
              </Col>
              <Col lg={4} md={6} style={{ marginBottom: "1rem" }}>
                <FormLabel
                  ms="4px"
                  fontSize="sm"
                  fontWeight="400"
                  fontFamily="Roboto"
                  color="#000000"
                >
                  Remote Status <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <input
                  type="radio"
                  name="remotestatus"
                  style={{ width: "25px" }}
                  value="Onsite"
                  checked={formik.values.remotestatus === "Onsite"}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  defaultChecked
                />{" "}
                Onsite
                <input
                  type="radio"
                  name="remotestatus"
                  style={{ width: "25px" }}
                  value="Remote"
                  checked={formik.values.remotestatus === "Remote"}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />{" "}
                Remote
                <input
                  type="radio"
                  name="remotestatus"
                  style={{ width: "25px" }}
                  value="Hybrid"
                  checked={formik.values.remotestatus === "Hybrid"}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />{" "}
                Hybrid &nbsp;
                {formik.touched.remotestatus && formik.errors.remotestatus ? (
                  <div style={{ color: "red", fontSize: "14px" }}>
                    {formik.errors.remotestatus}
                  </div>
                ) : null}
              </Col>
              <Col lg={4} md={6} style={{ marginBottom: "1rem" }}>
                <FormLabel
                  ms="4px"
                  fontSize="sm"
                  fontWeight="400"
                  fontFamily="Roboto"
                  color="#000000"
                >
                  Job Type <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <select
                  className="form-control"
                  name="jobtype"
                  value={formik.values.jobtype}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  style={{
                    width: "100%",
                    height: "37px",
                    border:
                      formik.touched.jobtype && formik.errors.jobtype
                        ? "1px solid red"
                        : "1px solid #ccc",
                  }}
                >
                  <option disabled={true} value="">
                    Job Type
                  </option>
                  <option value="Full Time">Full Time</option>
                  <option value="Part Time">Part Time</option>
                  <option value="Freelance">Freelance</option>
                </select>
                {formik.touched.jobtype && formik.errors.jobtype ? (
                  <div style={{ color: "red", fontSize: "14px" }}>
                    {formik.errors.jobtype}
                  </div>
                ) : null}
              </Col>

              <Col lg={4} md={6}>
                <FormLabel
                  ms="4px"
                  fontSize="sm"
                  fontWeight="400"
                  fontFamily="Roboto"
                  color="#000000"
                >
                  Industry <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <select
                  className="form-control"
                  name="industry"
                  value={formik.values.industry}
                  onChange={formik.handleChange}
                  style={{
                    width: "100%",
                    height: "37px",
                    border:
                      formik.touched.industry && formik.errors.industry
                        ? "1px solid red"
                        : "1px solid #ccc",
                  }}
                >
                  <option disabled={true} value="">
                    Select Industry
                  </option>
                  {industries?.map((val) => (
                    <>
                      <option value={val?.industry}>{val?.industry}</option>
                    </>
                  ))}
                </select>
                {formik.touched.industry && formik.errors.industry && (
                  <div style={{ color: "red", fontSize: "14px" }}>
                    {formik.errors.industry}
                  </div>
                )}
              </Col>
              <Col lg={4} md={6} style={{ marginBottom: "1rem" }}>
                <FormLabel
                  ms="4px"
                  fontSize="sm"
                  fontWeight="400"
                  fontFamily="Roboto"
                  color="#000000"
                >
                  Job Owner
                </FormLabel>
                <input
                  variant="auth"
                  fontSize="sm"
                  ms="4px"
                  type="text"
                  placeholder="Enter Your Skill"
                  mb="24px"
                  size="lg"
                  disabled
                  value={getCurrentLoggedInUserName?.label || "N/A"}
                  style={{
                    width: "100%",
                    height: "37px",
                    padding: "9px",
                  }}
                />
              </Col>
              <Col lg={4} md={6} style={{ marginBottom: "2rem" }}>
                <FormLabel
                  ms="4px"
                  fontSize="sm"
                  fontWeight="400"
                  fontFamily="Roboto"
                  color="#000000"
                >
                  Owner whatsapp number
                </FormLabel>
                <div className="candidatephone">
                  <PhoneInput
                    country={"in"}
                    containerStyle={{
                      border:
                        formik.touched.ownerPhone && formik.errors.ownerPhone
                          ? "1px solid red"
                          : "1px solid #ccc",
                      borderRadius: "4px",
                    }}
                    value={formik.values.ownerPhone}
                    onChange={(phone) => {
                      const cleanedPhone = phone.replace(/\D/g, "");
                      const formattedPhone = `+${cleanedPhone.slice(
                        0,
                        2
                      )} ${cleanedPhone.slice(2)}`;

                      const phoneNumberWithPlus = `+${phone}`;
                      formik.setFieldValue("ownerPhone", phoneNumberWithPlus);
                    }}
                  />
                  {formik.touched.ownerPhone && formik.errors.ownerPhone && (
                    <div style={{ color: "red", fontSize: "14px" }}>
                      {formik.errors.ownerPhone}
                    </div>
                  )}
                </div>
              </Col>
            </Row>
            <Box sx={{ marginBottom: "1rem" }}>
              <FormLabel
                ms="4px"
                fontSize="sm"
                fontWeight="400"
                fontFamily="Roboto"
                color="#000000"
              >
                Skill Required (separated by commas){" "}
                <span style={{ color: "red" }}>*</span>
              </FormLabel>
              <input
                variant="auth"
                fontSize="sm"
                type="text"
                placeholder="Enter Your Skill"
                size="lg"
                id="skill"
                name="skill"
                value={formik.values.skill}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                style={{
                  width: "100%",
                  position: "static",
                  height: "37px",
                  padding: "9px",
                  border:
                    formik.touched.skill && formik.errors.skill
                      ? "1px solid red"
                      : "1px solid #ccc",
                }}
              />
              {formik.touched.skill && formik.errors.skill ? (
                <div style={{ color: "red", fontSize: "14px" }}>
                  {formik.errors.skill}
                </div>
              ) : null}
            </Box>
            <Box sx={{ marginBottom: "1rem" }}>
              <FormLabel
                ms="4px"
                fontSize="sm"
                fontWeight="400"
                fontFamily="Roboto"
                color="#000000"
              >
                Questions
              </FormLabel>
              <input
                variant="auth"
                fontSize="sm"
                ms="4px"
                type="text"
                placeholder="Enter Your Questions"
                size="lg"
                id="question"
                name="question"
                value={formik.values.question}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                style={{
                  width: "100%",
                  height: "37px",
                }}
              />
            </Box>
            <Box mb={"24px"}>
              <Flex justifyItems={"center"}>
                <FormLabel
                  ms="4px"
                  fontSize="sm"
                  fontWeight="400"
                  fontFamily="Roboto"
                  color="#000000"
                >
                  Job description <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <Button
                  onClick={(e) => {
                    handleGenerateJD(e, formik, setJdLoading);
                  }}
                  borderRadius={"4px"}
                  isLoading={jdLoading}
                  className="bg_color"
                  size="sm"
                  mb={1}
                  _hover={"none"}
                  color={"#FFF"}
                >
                  Generate JD
                </Button>
              </Flex>

              <JobDescriptionEditor
                value={formik?.values?.jobdescription}
                valueFunc={(value) => {
                  formik.setFieldValue("jobdescription", value);
                }}
              />
              {formik.touched.jobdescription && formik.errors.jobdescription ? (
                <div style={{ color: "red", fontSize: "14px" }}>
                  {formik.errors.jobdescription}
                </div>
              ) : null}
            </Box>
          </Container>
          {/* For Salary Details */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h1
              style={{
                fontWeight: "bold",
                fontSize: "1.3rem",
                padding: "0.3rem",
                paddingBottom: "15px",
              }}
              className="usertitle"
            >
              Salary Details
            </h1>
          </div>
          <div
            style={{
              border: "1px solid #d3d1d1",
              width: "100%",
              height: "auto",
              borderRadius: "5px",
              padding: "10px",
            }}
          >
            <Container>
              <Row>
                <Col lg={4} md={4} style={{ marginBottom: "1rem" }}>
                  <label
                    style={{
                      fontSize: "13px",
                      fontWeight: "400",
                      fontFamily: "Roboto",
                      color: "#000000",
                    }}
                  >
                    Placement Type <span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    className="form-control"
                    name="placementType"
                    value={formik.values.placementType}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    style={{
                      height: "37px",
                      cursor: "pointer",
                      border:
                        formik.touched.placementType &&
                          formik.errors.placementType
                          ? "1px solid red"
                          : "1px solid #ccc",
                    }}
                  >
                    <option disabled={true} value="">
                      Select
                    </option>
                    <option>One Time Placement</option>
                    <option>Contractual</option>
                    <option>C2H</option>
                    <option>Temporary</option>
                  </select>
                  {formik.touched.placementType &&
                    formik.errors.placementType ? (
                    <div style={{ color: "red", fontSize: "14px" }}>
                      {formik.errors.placementType}
                    </div>
                  ) : null}
                </Col>
                <Col lg={4} md={4} style={{ marginBottom: "1rem" }}>
                  <label
                    style={{
                      fontSize: "13px",
                      fontWeight: "400",
                      fontFamily: "Roboto",
                      color: "#000000",
                    }}
                  >
                    Client Pay Type <span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    className="form-control"
                    name="clientpayType"
                    value={formik.values.clientpayType}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    style={{
                      height: "37px",
                      cursor: "pointer",
                      border:
                        formik.touched.clientpayType &&
                          formik.errors.clientpayType
                          ? "1px solid red"
                          : "1px solid #ccc",
                    }}
                  >
                    <option disabled={true} value="">
                      Select
                    </option>
                    <option>Monthly</option>
                    <option>Annual Salary</option>
                  </select>
                  {formik.touched.clientpayType &&
                    formik.errors.clientpayType ? (
                    <div style={{ color: "red", fontSize: "14px" }}>
                      {formik.errors.clientpayType}
                    </div>
                  ) : null}
                </Col>
                <Col lg={4} md={4}>
                  <label
                    style={{
                      fontSize: "13px",
                      fontWeight: "400",
                      fontFamily: "Roboto",
                      color: "#000000",
                    }}
                  >
                    CTC <span style={{ color: "red" }}>*</span>
                  </label>
                  <Input
                    variant="auth"
                    fontSize="sm"
                    type="text"
                    placeholder="CTC"
                    size="lg"
                    name="ctc"
                    value={formik.values.ctc}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    style={{
                      height: "37px",
                      border:
                        formik.touched.ctc && formik.errors.ctc
                          ? "1px solid red"
                          : "1px solid #ccc",
                    }}
                  />
                  {formik.touched.ctc && formik.errors.ctc ? (
                    <div style={{ color: "red", fontSize: "14px" }}>
                      {formik.errors.ctc}
                    </div>
                  ) : null}
                </Col>
              </Row>

              <Modal.Footer
                style={{ display: "flex", justifyContent: "center" }}
              >
                <Button
                  className="cancel"
                  type="button"
                  onClick={handlePostClose}
                >
                  Cancel
                </Button>
                <Button
                  className="bg_color"
                  color={"#fff"}
                  type="submit"
                  isDisabled={jobLoading}
                  isLoading={jobLoading}
                >
                  {formSubmitLoading ? <Spinner /> : "Save"}
                </Button>
              </Modal.Footer>
            </Container>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}

export default JobAddModal;
